import React from "react";
import { Nutrical } from "../../models/Neutrical";
import { UserTypeE } from "../UserType/UserType";
import "./Result.scss";


import palm from '../../assets/palm.png';
import fist from '../../assets/fist.png';
import handfull from '../../assets/handfull.png';
import thumb from '../../assets/thumb.png';
import { Diet } from "../../models/Goals";
import Logo from '../../assets/Logo.png';
import DialogComponent from "../../ui-elements/Dialog/Dialog";
import { CircularProgress, TextField } from "@mui/material";
import { AnalyticsApi, UserApi } from "../../api/user";
import axios from "axios";

interface ResultProp {
	nutrical: Nutrical;
}

interface inputValue {
	value: string | number,
	isError: boolean,
	errorText: string
}

const nutri = {
	name: '',
	age: 45,
	currentWeight: '56lbs',
	eatingStyle: 'Ketogenic',
	MacroPercentage: [20, 10, 70],
	dailyCalorie: 1335,
	reachGoal: 'Body Recompossiotion',
	nutriSections: [
		{
			portionSizeDay: '9 palm-sized portions',
			portionSizeDayW: '67g',
			portionSizeMeal: '1 total palm',
			portionSizeMealW: '22g',
			nutrient: 'protein',
			foods: ['Fish', 'Tofu', 'Chicken', 'Yougurt']
		},

		{
			portionSizeDay: '4-6 fist-sized portions',
			portionSizeDayW: '0',
			portionSizeMeal: '1 or 2 total fist',
			portionSizeMealW: '0',
			nutrient: 'veggies',
			foods: ['Spinach', 'Cauliflower', 'Carrots', 'Tomatoes']
		},

		{
			portionSizeDay: '1 cupped handfuls',
			portionSizeDayW: '2g',
			portionSizeMeal: '1 total handfuls',
			portionSizeMealW: '1g',
			nutrient: 'carbs',
			foods: ['Beans', 'Sweet Potatoes', 'Blue Berries', 'Oats']
		},

		{
			portionSizeDay: '11 thumb-sized portions',
			portionSizeDayW: '92g',
			portionSizeMeal: '3 or 4 total thumbs',
			portionSizeMealW: '30g',
			nutrient: 'healthy fats',
			foods: ['Olive Oil', 'Walnut', 'Pesto', 'Cheese']
		},
	]
}




const Result: React.FC<ResultProp> = ({ nutrical }): JSX.Element => {
	const [open, setOpen] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const [name, setName] = React.useState<inputValue>({ value: "", isError: false, errorText: "" });
	const [email, setEmail] = React.useState<inputValue>({ value: "", isError: false, errorText: "" });
	const [phoneNo, setPhoneNo] = React.useState<inputValue>({ value: "", isError: false, errorText: "" });
	const [infoCollected, setInfoCOllected] = React.useState(false);
	const ref = React.createRef();

	React.useEffect(() => {
		AnalyticsApi.logEvent('Result Viewed');
		setUpNutriParams();
	}, []);

	const printDocument = () => {
		setLoading(true);
		axios.post('https://us-central1-nutrition-calculator-18ab7.cloudfunctions.net/getPdfUrl', { nutri }, { responseType: 'blob' })
		//axios.post(`http://localhost:5001/nutrition-calculator-18ab7/us-central1/getPdfUrl`, { nutri }, { responseType: 'blob' })
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data],
					{ type: 'application/pdf' }));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', "SaaraLife-nutrition-calculation.pdf");
				document.body.appendChild(link);
				link.click();
				setLoading(false);
			})
			.catch(err=>{
				setLoading(false);
			})
	}

	const setUpNutriParams = () => {
		nutri.age = nutrical.detail.age!;
		nutri.currentWeight = nutrical.detail.getWeight();
		nutri.eatingStyle = nutrical.goal.getEatingStyle();
		nutri.MacroPercentage = [nutrical.goal.macroNutrient?.macroRatio.protein!,
		nutrical.goal.macroNutrient?.macroRatio.carbs!,
		nutrical.goal.macroNutrient?.macroRatio.fats!];
		nutri.reachGoal = nutrical.goal.getReachGoal();
		nutri.dailyCalorie = Math.round(nutrical.rmrActivityGoal);

		nutri.nutriSections[0].nutrient = 'protein';
		nutri.nutriSections[0].portionSizeDay = nutrical.palmsProtein + ' palm-sized portions';
		nutri.nutriSections[0].portionSizeDayW = Math.round(nutrical.gramsProtein) + 'g';
		nutri.nutriSections[0].portionSizeMeal = nutrical.getProteinPalmText();
		nutri.nutriSections[0].portionSizeMealW = Math.round(nutrical.gramsPerMealProtein) + 'g';

		nutri.nutriSections[1].nutrient = 'veggies';
		nutri.nutriSections[1].portionSizeDay = nutrical.getVegFistTotalText() + ' fist-sized portions';
		nutri.nutriSections[1].portionSizeMeal = nutrical.getVegFistText();
		nutri.nutriSections[1].foods = ['Spinach (Nivithi)', 'Cabbage', 'Pennywort (Gotukola)', 'Carrot'];

		nutri.nutriSections[2].nutrient = 'carbs';
		nutri.nutriSections[2].portionSizeDay = nutrical.cuppedHandCarb + ' cupped handfuls';
		nutri.nutriSections[2].portionSizeDayW = Math.round(nutrical.gramsCarb) + 'g';
		nutri.nutriSections[2].portionSizeMeal = nutrical.getCarbHandText();
		nutri.nutriSections[2].portionSizeMealW = Math.round(nutrical.gramsPerMealCarb) + 'g';
		nutri.nutriSections[2].foods = ['Beans', 'Sweet Potatoes', 'Red rice', 'Manioc (cassava)'];

		nutri.nutriSections[3].nutrient = 'healthy fats';
		nutri.nutriSections[3].portionSizeDay = nutrical.thumbsFat + ' thumb-sized portions';
		nutri.nutriSections[3].portionSizeDayW = Math.round(nutrical.gramsFat) + 'g';
		nutri.nutriSections[3].portionSizeMeal = nutrical.getFatThumText();
		nutri.nutriSections[3].portionSizeMealW = Math.round(nutrical.gramsPerMealFat) + 'g';

	}

	const printProtein = () => {
		if (nutrical.goal.eatingStyle === Diet.Vegetarian) {
			return (<ul className="ul-green">
				<li>Chickpeas</li>
				<li>Seitan</li>
				<li>Eggs</li>
				<li>Greek Yougurt</li>
			</ul>

			)
		} else if (nutrical.goal.eatingStyle === Diet.PlantBased) {
			return (
				<ul className="ul-green">
					<li>Chickpeas</li>
					<li>Seitan</li>
					<li>Mung beans</li>
					<li>Lentils</li>
				</ul>
			)
		} else {
			return (
				<ul className="ul-green">
					<li>Fish</li>
					<li>Chicken</li>
					<li>Mung beans</li>
					<li>Yougurt</li>
				</ul>
			)
		}
	}

	const printFats = () => {
		if (nutrical.goal.eatingStyle === Diet.PlantBased) {
			return (
				<ul className="ul-red">
					<li>Olive Oil</li>
					<li>Walnut</li>
					<li>Fresh coconut</li>
					<li>Cashew nuts</li>
				</ul>
			)
		} else {
			return (
				<ul className="ul-red">
					<li>Olive Oil</li>
					<li>Cashew nuts</li>
					<li>Walnut</li>
					<li>Cheese</li>
				</ul>
			)
		}
	}


	const handleClickOpen = () => {
		AnalyticsApi.logEvent('Dowload_PDF_Clicked');
		if (!infoCollected) {
			setOpen(true);
		} else {
			printDocument();
		}

	};

	const handleClose = (): void => {
		setOpen(false);
	};

	const onValueChange = (inputType: string, value: string | number) => {
		switch (inputType) {
			case 'name':
				name.value = value;
				setName({ value: value, isError: false, errorText: "" });
				break;
			case 'email':
				email.value = value;
				setEmail({ value: value, isError: false, errorText: "" });
				break;
			case 'phoneNo':
				phoneNo.value = value;
				setPhoneNo({ value: value, isError: false, errorText: "" });
				break;
		}
	}

	const handleDowloadClick = () => {
		let invalidInput = false;

		if (name.value === '') {
			setName({ value: name.value, isError: true, errorText: 'Name is mandatory' });
			invalidInput = true;
		}

		if (email.value === '') {
			setEmail({ value: email.value, isError: true, errorText: 'Email is mandatory' });
			invalidInput = true;
		} else if (!String(email.value)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			)) {
			setEmail({ value: email.value, isError: true, errorText: 'Invalid email format' });
			invalidInput = true;
		}

		if (!invalidInput) {
			nutri.name = name.value as string;
			UserApi.writeUserData(name.value as string, email.value as string, phoneNo.value as string);
			//Storage.setWithExpiry('infoCollected', 'true', 24 * 60 * 60 * 1000);// expiry set to 1h.

			printDocument();
			setOpen(false);
			setInfoCOllected(true);
		}
	}

	return (
		<>
			<div className="content">
				<div>Here’s a PDF of your results!</div>

				{
					loading ? (<CircularProgress />) : (
						<button onClick={handleClickOpen} className="greenButton">
							Download PDF
						</button>
					)
				}
				<div className='result-content' id='result-content'>
					<div className="summary">
						<div className="horizontalLine"></div>

						<h2 className="title">Brief  Summary</h2>
						<div className="summary-item">
							<span className="summary-text">Age</span>
							<span className="summary-value">
								{nutrical.detail.age}
							</span>
						</div>
						<div className="horizontalLine"></div>

						<div className="summary-item">
							<span className="summary-text">Current Weight</span>
							<span className="summary-value">
								{nutrical.detail.getWeight()}
							</span>
						</div>
						<div className="horizontalLine"></div>

						<div className="summary-item">
							<span className="summary-text">Eating Style</span>
							<span className="summary-value">
								{nutrical.goal.getEatingStyle()}
							</span>
						</div>
						<div className="horizontalLine"></div>

						<div className="summary-item">
							<span className="summary-text">Macro Percentage</span>
							<span className="summary-value">

								<span className="field-blue   field">~{nutrical.goal.macroNutrient?.macroRatio.protein}% Protein</span>
								<span className="field-orange field">~{nutrical.goal.macroNutrient?.macroRatio.carbs}% Carbs</span>
								<span className="field-yellow field">~{nutrical.goal.macroNutrient?.macroRatio.fats}% Fats</span>

							</span>
						</div>
						<div className="horizontalLine"></div>

						<div className="summary-body">
							To maintain {nutrical.userType === UserTypeE.Client ? "their" : "your"} current weight requires about <b>{Math.round(nutrical.rmrActivity)} Calories per day.</b>
						</div>

						<div className="summary-body">
							To reach the goal of <b>{nutrical.goal.getReachGoal()}</b> at {nutrical.userType === UserTypeE.Client ? "their" : "your"}  current body weight and activity level
							requires about:
						</div>

						<h2 className="title">{Math.round(nutrical.rmrActivityGoal)} Calories per day.</h2>

						<div className="grey-title">HERE'S HOW THAT BREAKS DOWN:</div>
					</div>

					<div className="result-table">
						<div className="horizontalLine"></div>
						<div className="result-row">
							<div className="result-image">
								<img
									className="main-image hand-image"
									src={palm}
									alt="palm"
								/>
							</div>
							<div className="result-text">
								<div className="result-main-text">
									{nutrical.palmsProtein} palm-sized portions (or {Math.round(nutrical.gramsProtein)} g) of
									<span className="field-green"> protein</span> per day
								</div>
								<div className="result-sub-text">That's <b>{nutrical.getProteinPalmText()}</b> or <b>{Math.round(nutrical.gramsPerMealProtein)}</b> g per meal.</div>
								<div className="result-example field-green">FOR EXAMPLE</div>

								{printProtein()}
							</div>
						</div>
						<div className="horizontalLine"></div>

						<div className="result-row">
							<div className="result-image">
								<img
									className="main-image hand-image"
									src={fist}
									alt="fist"
								/>
							</div>
							<div className="result-text">
								<div className="result-main-text">
									{nutrical.getVegFistTotalText()} fist-sized portions of
									<span className="field-blue"> veggies </span>per day
								</div>
								<div className="result-sub-text">That's <b>{nutrical.getVegFistText()}</b> per meal.</div>
								<div className="result-example field-blue">FOR EXAMPLE</div>

								<ul className="ul-blue">
									<li>Spinach (Nivithi)</li>
									<li>Pennywort (Gotukola)</li>
									<li>Cabbage</li>
									<li>Carrot</li>
								</ul>
							</div>
						</div>
						<div className="horizontalLine"></div>

						<div className="result-row">
							<div className="result-image">
								<img
									className="main-image hand-image"
									src={handfull}
									alt="handfull"
								/>
							</div>
							<div className="result-text">
								<div className="result-main-text">
									{nutrical.cuppedHandCarb} cupped handfuls (or {Math.round(nutrical.gramsCarb)} g) of
									<span className="field-orange"> Carbs </span>per day
								</div>
								<div className="result-sub-text">That's <b>{nutrical.getCarbHandText()}</b> or <b>{Math.round(nutrical.gramsPerMealCarb)}g</b> per meal.</div>
								<div className="result-example field-orange">FOR EXAMPLE</div>

								<ul className="ul-orange">
									<li>Beans</li>
									<li>Red rice</li>
									<li>Sweet Potatoes</li>
									<li>Manioc (cassava)</li>
								</ul>
							</div>
						</div>
						<div className="horizontalLine"></div>

						<div className="result-row">
							<div className="result-image">
								<img
									className="main-image hand-image"
									src={thumb}
									alt="thumb"
								/>
							</div>
							<div className="result-text">
								<div className="result-main-text">
									{nutrical.thumbsFat} thumb-sized portions (or {Math.round(nutrical.gramsFat)} g) of
									<span className="field-red"> healthy fats </span>per day
								</div>
								<div className="result-sub-text">That's <b>{nutrical.getFatThumText()}</b> or <b>{Math.round(nutrical.gramsPerMealFat)}g</b> per meal.</div>
								<div className="result-example field-red">FOR EXAMPLE</div>

								{printFats()}
							</div>
						</div>
						<div className="horizontalLine"></div>
					</div>
				</div>
			</div>
			<DialogComponent open={open} onClose={handleClose}>
				<div className="dialog-logo-container">
					<img
						className="dialog-logo"
						src={Logo}
						alt="SaaraLife Logo"
					/>
				</div>

				<div className="dialog-body">
					<TextField id="name"
						className='input-field' label="Name" variant="outlined"
						value={name.value}
						error={name.isError}
						helperText={name.errorText}
						required
						onChange={(e) => onValueChange('name', e.target.value)}
					/>

					<TextField id="email" label="Email" variant="outlined"
						error={email.isError}
						value={email.value}
						helperText={email.errorText}
						required
						onChange={(e) => onValueChange('email', e.target.value)} />

					<TextField
						id="phoneNumber" label="Phone Number" variant="outlined"
						value={phoneNo.value}
						onChange={(e) => onValueChange('phoneNo', e.target.value)}
					/>

					<button onClick={handleDowloadClick} className="greenButton">
						Download PDF
					</button>
				</div>
			</DialogComponent>
		</>
	);
};

export default Result;
